import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { Vendor } from '../../redux-toolkits/vendors/vendors.types'
import { EditInput } from '../inputs/editInput'

const creatorFulfillmentTypeOptions = [
  {
    label: 'Onsite',
    description: 'Good warehouses and fulfils this creator’s products.',
    value: false,
  },
  {
    label: 'Offsite',
    description: 'The creator fulfils orders directly.',
    value: true,
  },
]

export const VendorOffsiteCreator = ({
  vendor,
  loading = false,
  onModify,
  className = '',
}: {
  vendor?: Vendor
  loading?: boolean
  onModify: (
    data: { isOffsiteCreator: boolean },
    handleClose: () => void,
  ) => void
  className?: string
}) => {
  const [editing, setEditing] = useState(false)
  const [isOffsiteCreator, setIsOffsiteCreator] = useState(false)

  useEffect(() => {
    setIsOffsiteCreator(!!vendor?.isOffsiteCreator)
  }, [vendor?.isOffsiteCreator])

  return (
    <div className={className}>
      <EditInput
        onEditSave={() => {
          onModify({ isOffsiteCreator }, () => {
            setEditing(false)
          })
        }}
        editing={editing}
        onEditClick={() => {
          setEditing(true)
        }}
        onCancel={() => {
          setIsOffsiteCreator(!!vendor?.isOffsiteCreator)
          setEditing(false)
        }}
        title="Creator type"
        loading={loading}
      >
        {({ isEditing }) => {
          return isEditing ? (
            <div
              className="grid w-full grid-cols-1 gap-3 md:grid-cols-2"
              role="radiogroup"
              aria-label="Creator type"
            >
              {creatorFulfillmentTypeOptions.map((option) => {
                const active = option.value === isOffsiteCreator

                return (
                  <button
                    key={option.label}
                    type="button"
                    role="radio"
                    aria-checked={active}
                    className={classNames(
                      'flex min-h-[92px] flex-col items-start justify-center rounded-[8px] border px-4 py-3 text-left transition-all',
                      active
                        ? 'border-black bg-black text-white'
                        : 'border-divider-gray bg-white text-black hover:border-black',
                    )}
                    onClick={() => {
                      setIsOffsiteCreator(option.value)
                    }}
                  >
                    <span className="text-sm font-medium">{option.label}</span>
                    <span
                      className={classNames('mt-1 text-xs leading-5', {
                        'text-light-gray': active,
                        'text-sec-black': !active,
                      })}
                    >
                      {option.description}
                    </span>
                  </button>
                )
              })}
            </div>
          ) : (
            <div>{vendor?.isOffsiteCreator ? 'Offsite' : 'Onsite'}</div>
          )
        }}
      </EditInput>
    </div>
  )
}
